import { render, staticRenderFns } from "./pencil-13.vue?vue&type=template&id=6750aefe&scoped=true"
import script from "./pencil-13.vue?vue&type=script&lang=js"
export * from "./pencil-13.vue?vue&type=script&lang=js"
import style0 from "./pencil-13.vue?vue&type=style&index=0&id=6750aefe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6750aefe",
  null
  
)

export default component.exports